import CIMClosuresPage from './CIMClosuresPage';

export default CIMClosuresPage;
